<template>
	<div class="body">
		<div class="body-container">

			<el-table :data="list" :span-method="spanMethod" border stripe v-loading="loading" element-loading-text="处理中，请耐心等待...">
				<el-table-column label="岗位群名称" align="center" prop="job_name">
				</el-table-column>
				<el-table-column label="典型工作任务" align="left" prop="task_name">
				</el-table-column>
				<el-table-column label="素质要求" align="left" prop="content">
					<template v-slot="{ row }">
						<div class="wrap-content">{{formatTextWithLineBreaks(row.quality)}}</div>
					</template>
				</el-table-column>
				<el-table-column label="知识要求" align="left" prop="content">
					<template v-slot="{ row }">
						<div class="wrap-content">{{formatTextWithLineBreaks(row.knowledge)}}</div>
					</template>
				</el-table-column>
				<el-table-column label="技能要求" align="left" prop="content">
					<template v-slot="{ row }">
						<div class="wrap-content">{{formatTextWithLineBreaks(row.skill)}}</div>
					</template>
				</el-table-column>
			</el-table>

		</div>

		<div class="action-ctr" v-if="isDone">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">生成推荐课程</el-button>
		</div>


	</div>
</template>

<script>
	import { applyPatch } from 'fast-json-patch'
	import {
		queryJobAbilityData,
		toExportAbilityReport,
		calcuJobCareerCourse
	} from "@/api/matrix"
	
	import aiChatService from '@/utils/aiChat'

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				list: [],
				spanMap: {},
				params: {
					page: 1,
					pageSize: 20
				},
				total: 0,
				showCareerDialog: false,
				acceptMap: {},
				careerData: null,
				showCreateDialog: false,
				companyName: '',
				jobName: '',
				jobDescription: '',
				loading: true,
				currentEventSource: null,
				isDone: false
			}
		},
		created() {
			this.initPageData();
		},

		beforeDestroy() {
			// 清理资源
			if (this.currentEventSource) {
				this.currentEventSource.close();
			}
			// aiChatService.cancelRequest();
		},


		methods: {
			initPageData() {
				// this.requestData();
				this.retryTimes = 0;
				this.streamData();
			},

			requestData() {
				let that = this;
				this.id = this.$route.query.id;
				this.params['id'] = this.id;
				queryJobAbilityData(this.params).then(res => {
					console.log('groupId', this.groupId)
					let realData = res.data;
					
					if (realData['done'] != 1){
						setTimeout(function(){
							that.requestData();
						}, 1000)
					}else{
						this.list = realData.list;
						
						this.spanMap = getSpanMap(this.list, ['job_name'])
						this.loading = false;
					}
					
					// this.title = realData.title;
				});
			},
			
			async streamData(){
				this.id = this.$route.query.id;
				this.params['id'] = this.id;
				this.isDone = false;
				this.lastData = null;
				this.retryTimes += 1;
				try {
					// 使用流式对话
					await aiChatService.customeStream('matrix/streamJobAbility', this.params,
						{
							onMessage: (chunk) => {
								let patchData = chunk.patchData;
							
								if (patchData){
									// console.log('onMessage lastData', this.lastData)
									// console.log('onMessage patchData', patchData)
									// console.log('----------------------')
									let newData = applyPatch(this.lastData, patchData)
									this.list = newData.newDocument;
								}else{
									// console.log('onMessage chunk.data-----------', chunk.data)
									this.list = chunk.data;									
								}
								
								let hasData = this.loading && this.list && this.list.length > 0;
								// console.log('this.loading hasData', hasData)
								if (hasData){
									this.loading = false;
									console.log('this.loading2222222222', this.loading)
								}
								
								
								this.lastData = this.list;		
								this.spanMap = getSpanMap(this.list, ['job_name'])
							},
			
							onComplete: (data) => {
								console.log('对话完成onComplete:', data);
								Message({
									message: '已分析完成',
									type: 'success'
								})
							},
			
							onError: (error) => {
								console.log('error', error)
								this.$message.error('请求失败: ' + error);
				
							},
			
							onDone: () => {
								console.log('对话完成onDone:');
								this.isDone = true;
							},
						}
					);
			
				} catch (error) {
					console.error('对话异常:', error);
					if(this.retryTimes > 10){
						this.showRetryDialog();
					}else{
						this.streamData();
					}
					
				}			
			},
			
			showRetryDialog(){
				this.$confirm('数据量较大，是否继续输出?', '温馨提示', {
					confirmButtonText: '继续',
					cancelButtonText: '取消',
					type: 'warning', // 图标类型：success, warning, info, error,
					distinguishCancelAndClose: true,
				}).then(() => {
					this.retryTimes = 0;
					this.streamData();
				}).catch((action) => {	
					console.log('action', action);
				});
			},
			
			
			spanMethod({
				row,
				column,
				rowIndex
			}) {
				const colProp = column.property // 当前列字段名
				if (this.spanMap[colProp]) {
					const rowspan = this.spanMap[colProp][rowIndex]
					return {
						rowspan,
						colspan: rowspan === 0 ? 0 : 1
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},
					
			// 方法：格式化文本
			formatTextWithLineBreaks(text) {
				text = text.replaceAll('；', '；\n')
				text = text.replaceAll(';', '；\n')
				return text;
			},
			
			clickNext(){
				calcuJobCareerCourse(this.params).then(res => {
					let realData = res.data;
					
					let id = realData['id']
					let path = '/job_course?id=' + id;
					this.$router.push(path);
				});
			}
			
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "job_ability.scss";
</style>